module.exports = __webpack_public_path__ + "img/36.44a2ca70.jpg";